import React, { ReactNode } from "react";
import { LinhaTabela } from "shared/components/table/LinhaTabela";
import { RegistroTabela } from "shared/components/table/RegistroTabela";
import { getSituacaoAcordoFormatado, TipoSituacaoAcordo } from "constants/EnumTipoSituacaoAcordo";
import { RegistroAcordoDTO } from "types/dto/RegistroAcordoDTO";
import { formatarValorMonetario } from "shared/util/functions/formatacoesDeValores/FormatarValores";
import { useGestaoCobrancaCadastroContext } from "context/gestaoCobranca/GestaoCobrancaCadastroContext";
import { Tooltip } from "@mui/material";
import { AiFillFileText } from "react-icons/ai";
import { BsFillFileEarmarkPdfFill } from "react-icons/bs";
import useGetEmitirRelatorioAcordoDetalhado from "hooks/relatorios/useGetEmitirRelatorioAcordoDetalhado";
import { useGetEmitirRelatorioConfissaoDeDivida } from "hooks/relatorios/useGetEmitirRelatorioConfissaoDeDivida";
import { RequestFiltroRelatorio } from "types/request/RequestFiltroRelatorio";

interface RenderRowsProps {
  registros: RegistroAcordoDTO[];
}

export const RenderRowsAcordosRealizados: React.FC<RenderRowsProps> = (props) => {
  const { condominioId, possuiPermissaoEmitirAcordoDetalhado, possuiPermissaoEmitirConfissaoDeDivida } =
    useGestaoCobrancaCadastroContext();

  const { emitirRelatorioAcordoDetalhado } = useGetEmitirRelatorioAcordoDetalhado();
  const { emitirRelatorioConfissaoDeDivida } = useGetEmitirRelatorioConfissaoDeDivida();

  const emitirAcordoDetalhado = (numeroAcordo: number) => {
    let filtroRelatorio = {
      condominioId,
      numeroAcordo,
    } as RequestFiltroRelatorio;
    emitirRelatorioAcordoDetalhado(filtroRelatorio);
  };

  const emitirTermoDeAcordoConfissaoDeDivida = async (acordoId: number) => {
    emitirRelatorioConfissaoDeDivida(acordoId);
  };

  const renderRegistros = (registros: RegistroAcordoDTO[]): ReactNode => {
    return registros.map((acordo: RegistroAcordoDTO, index: number) => {
      return (
        <LinhaTabela id={`id-registro-acordos-realizados-${index}`} key={`key-registro-acordos-realizados-${index}`}>
          <RegistroTabela id={`numero-acordo-${acordo.id}`} key={`numero-acordo-${acordo.id}`}>
            <span>{acordo.numeroAcordo}</span>
          </RegistroTabela>

          <RegistroTabela id={`numero-parcelas-acordo-${acordo.id}`} key={`numero-parcelas-acordo-${acordo.id}`}>
            <span>{acordo.numeroParcelas}</span>
          </RegistroTabela>

          <RegistroTabela id={`valor-acordo-${acordo.id}`} key={`valor-acordo-${acordo.id}`}>
            <span>{formatarValorMonetario(acordo.valor)}</span>
          </RegistroTabela>

          <RegistroTabela id={`valor-acordado-${acordo.id}`} key={`valor-acordado-${acordo.id}`}>
            <span>{formatarValorMonetario(acordo.valorAcordado)}</span>
          </RegistroTabela>

          <RegistroTabela id={`situacao-acordo-${acordo.id}`} key={`situacao-acordo-${acordo.id}`}>
            <span>{getSituacaoAcordoFormatado(acordo.situacaoAcordo)}</span>
          </RegistroTabela>
          <RegistroTabela id={`acoes-acordo-${acordo.id}`} key={`acoes-acordo-${acordo.id}`}>
            {possuiPermissaoEmitirAcordoDetalhado && (
              <Tooltip title="Emitir relatório de acordo" placement="top">
                <a>
                  <AiFillFileText
                    onClick={() => emitirAcordoDetalhado(acordo.numeroAcordo)}
                    className="me-2"
                    size={17}
                    color="#a69ae7"
                  />
                </a>
              </Tooltip>
            )}
            {possuiPermissaoEmitirConfissaoDeDivida && (
              <Tooltip title="Emitir termo de acordo e confissão de dívida" placement="top">
                <a>
                  <BsFillFileEarmarkPdfFill
                    onClick={() => emitirTermoDeAcordoConfissaoDeDivida(acordo.id)}
                    className={` ${
                      acordo.situacaoAcordo === TipoSituacaoAcordo.CANCELADO ? "disable-icon" : "cursor-pointer"
                    }`}
                    size={17}
                    color="#a69ae7"
                  />
                </a>
              </Tooltip>
            )}
          </RegistroTabela>
        </LinhaTabela>
      );
    });
  };

  return <>{props.registros.length > 0 && renderRegistros(props.registros)}</>;
};
